import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import '../app.css'
import App from '../App.vue'
import bettingRoutes from '../router/routes/betting'
import { initSentry } from '../lib/sentry'

// Branding
document.title = 'Betting | Codifyo'
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', '/favicon-sport.png') // using sport icon as placeholder
}

const router = createRouter({
    history: createWebHistory(),
    routes: bettingRoutes,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('apiToken')) {
        next({ name: 'betting_login' });
    } else {
        next()
    }
})

const app = createApp(App)
app.use(router)
initSentry(app, router)
app.mount('#app')
